import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';

export interface IBotMessageChoiceWidget {
  readonly title?: string;
  readonly options?: string[];
}

export interface IBotMessage {
  readonly id: string;
  readonly html: string;
  readonly rm: boolean;
  readonly nodeId: string;
  readonly icon?: 'flag' | 'info' | 'alert' | 'warning' | 'success';
  readonly type: MESSAGES.BOT_MESSAGE;
  readonly role: ROLE;
  // TODO: deprecated in Chatbot V2, remove when merging the experiment
  readonly avatar: boolean;
  readonly preventScroll?: boolean;
  readonly animate?: boolean;
  readonly choiceWidget?: IBotMessageChoiceWidget;
}

export const createBotMessage = (data): IBotMessage => ({
  id: data.id || uuid(),
  html: data.html,
  rm: Boolean(data.rm),
  nodeId: data.nodeId,
  icon: data.icon,
  type: MESSAGES.BOT_MESSAGE,
  role: ROLE.BOT,
  avatar: true,
  preventScroll: Boolean(data.preventScroll),
  animate: Boolean(data.animate),
  ...(data.choiceWidget && { choiceWidget: data.choiceWidget }),
});
